import React, { Component } from 'react';

export default class GroupsTopBar extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    render() {

        let outerStyle = {};
        if (this.props.isScanMode) {
            outerStyle.top = '-6rem';
            outerStyle.pointerEvents = 'none';
        }

        return (
            <div className={"groups-top-bar-outer"} style={outerStyle}>
                {
                    this.props.topBarSettings.backFunction === null ?
                        <div className={"groups-top-bar-menu-button material-icons"} onClick={this.props.toggleNav}>menu</div>
                        :
                        <div className={"groups-top-bar-menu-button material-icons"} onClick={this.props.topBarSettings.backFunction}>arrow_back</div>
                }
                <div className={"groups-top-bar-title-container"}>{"Groups"}</div>
                <div className={"material-icons groups-top-bar-action-button" + (this.props.topBarSettings.actionFunction === null ? " hidden" : "")}
                    onClick={this.props.topBarSettings.actionFunction}>
                    {this.props.topBarSettings.icon}
                </div>
            </div>
        );
    }
}

